import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector:'[right-menu-content]'
})
export class MapMenuContentDirective{
  constructor(public viewContainerRef:ViewContainerRef){}
}
